/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 16:43:08
 */ 
export const integralEn = {
    xunjiadang:'Integral management',
    wodejifeng:'My points',
    linquyouhuiquan:'Collect coupons',
    zuijinsangeyue:'Points statistics of the last three months',
    jifengmingxi:'Integral details',
    jifenghuoqu:'Type of points obtained',
    qingshuru:'Please enter service name  keyword',
    sousuo:'search',
    qingxuanzhe:'Choose',
    laiyuan:'Source / purpose',
    jifengbianhua:'Integral change',
    riqi:'date',
    beizhu:'Remarks',
    lingquyhq: "Points management - Get coupons",
    jifenglq: "Points management",
    duihuanmalq: "Exchange code collection",
    sfkdh: "Whether it is convertible:",
    zhifengzhi: "integral:",
    jifengyt: "Integral purposes",
    shengyusl: "residual quantity",
    lingquzf: "Get the integral",
    xianlingsl: "Limit get number",
    lijilingqu: "Immediately to receive",
    qsryhqdhm: "Please enter coupon redemption code:",
    shuoming: "Please note the expiry date of the exchange code. The coupon will not be redeemed if the code is late",
    qsryzm: "Please enter the verification code:",
    kanbuqinghyz: "I can't see it. Change it",
    shuoming2: "Please note that if you have already received the coupon through another channel, you will not be able to receive it through the exchange code",
    gxnlqcg: "Congratulations on your success!",
    lingqucg: "You can check it in 'My Coupon' after you have received it successfully",
    lingqusb: "Sorry, your points are not enough, get fail!",
    bukeduihuan: "inconvertibility",
    keduihuan: "exchangeable",
    xaiofeizf: "consumption points ",
    pinglunzf: "Comments on the integral",
    shiyongzf: "Using the integral",
}


// WEBPACK FOOTER //
// ./src/lang/member/integral/integralEn.js